<template>
  <div>
    <v-card tile flat class="my-5">
      <v-card-text class="pa-0">
        <v-row no-gutters>
          <v-col cols="2">
            <div class="bg-kiri"></div>
          </v-col>
          <v-col cols="10" class="pa-5">
            <v-list three-line>
              <v-list-item class="px-0">
                <v-list-item-avatar color="blue" size="50">
                  <v-icon dark size="35">mdi-account</v-icon>
                </v-list-item-avatar>
                <v-list-item-content class="py-0 px-1">
                  <v-row>
                    <v-col cols="12" lg="6">
                      <div class="body-2 grey--text">Nama Koordinator FSP</div>
                      <div class="body-1 black--text">
                        {{ $getDeepObj(meta, 'koordinator.nama') || akun.nama }}
                      </div>
                      <div class="body-2">
                        <strong>Email: </strong> {{ $getDeepObj(meta, 'koordinator.email') || akun.email }}
                      </div>
                    </v-col>
                    <v-col cols="12" lg="6">
                      <div class="body-2 grey--text">Instansi</div>
                      <div class="body-1 black--text">
                        {{ $getDeepObj(meta, 'instansi.nama') || instansi.nama }}
                      </div>
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card tile flat>
      <v-card-text class="pa-5 mb-7">
        <v-row>
          <v-col cols="12" lg="9" class="my-auto black--text"><h3>Daftar Laporan Kegiatan Koordinator FSP</h3></v-col>
          <v-col cols="12" lg="3" class="my-auto text-right">
            <div v-if="tahun" class=" black--text font-weight-medium"> Tahun Pendampingan {{ tahun }} </div>
            <div v-else>
              <v-select
                v-model="pendampingan_tahun"
                light
                flat
                dense
                outlined
                hide-details
                :items="mTahunPendampingan"
                @change="onChangeTahunPendampingan"
              ></v-select>
            </div>
          </v-col>
        </v-row>
        <v-divider class="my-4" />
        <div v-if="pendampingan_tahun >= 2024">
          <laporan2024
            form="ds24"
            :meta="meta"
            :laporans="laporans"
            :akun-instansi-id="akunInstansiId"
            @laporan="onEditLaporan"
          />
        </div>
        <div v-else>
          <v-tabs v-model="tab" hide-slider>
            <v-row>
              <template v-for="(item, i) in tabItems">
                <v-col cols="12" :lg="12 / tabItems.length" :key="i">
                  <v-tab
                    :class="[
                      i === tab ? 'green lighten-4' : '',
                      'green--text text-capitalize body-2 font-weight-medium',
                    ]"
                    :disabled="item.disabled"
                    :key="i"
                    style="border: 1px solid #00bfa5; border-radius: 5px; width: 100% !important; max-width: 100%; height: 100%"
                  >
                    {{ item.label }}
                  </v-tab>
                </v-col>
              </template>
            </v-row>

            <v-tab-item class="mt-2" v-for="(item, i) in tabItems" :key="i">
              <div
                :ref="`laporan-${i}`"
                :is="item.component"
                :master-instrumen="item.masterInstrumen"
                :form="item.form"
                :status="status"
                :meta="meta"
                :laporans="laporans"
                :laporans-fsp="laporansFsp"
                :laporans-progres="laporansProgres"
                :akun-instansi-id="akunInstansiId"
                :pendampingan-tahun="pendampingan_tahun"
                @pendampingan="onChangePendampingan"
                @laporan="onEditLaporan"
              ></div>
            </v-tab-item>
          </v-tabs>
        </div>
      </v-card-text>
    </v-card>
    <base-modal-full ref="modal" :title="formulir.title" :useSave="!formulir.isPreview" @save="onSaveLaporan">
      <component
        ref="formulir"
        :masters="Object.assign({}, masters)"
        :meta="meta"
        :is="formulir.form"
        :info="formulir.info"
        :berkases="formulir.berkases"
        :sekolahs="formulir.sekolahs"
        :type="formulir.type"
        :is-preview="formulir.isPreview"
        :progres-id="formulir.progresId"
        @refresh="onRefreshLaporan"
      />
    </base-modal-full>
  </div>
</template>

<script>
import Laporan from './components/Laporan';
import LaporanSekolah from './components/LaporanSekolah';
import LaporanProgres from './components/LaporanProgres';
import Laporan2024 from './components/Laporan2024';
import FormKoordinator from './forms/Koordinator';
import FormProgres from './forms/Progres';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'KoordinatorFspIndex',
  components: { Laporan, LaporanSekolah, LaporanProgres, Laporan2024, FormKoordinator, FormProgres },
  props: {
    akunInstansiId: {
      default: '',
    },
  },
  data() {
    return {
      pendampingan_ke: null,
      pendampingan_tahun: null,
      tab: null,
      meta: {},
      laporans: {},
      laporansFsp: {},
      laporansProgres: {},
      formulir: {},
    };
  },
  computed: {
    ...mapState('master', ['masters']),
    ...mapState('preferensi', {
      akun: (state) => state.data?.akun ?? {},
      instansi: (state) => state.data?.instansi ?? {},
      configPendampingan: (state) => state.data?.pendampingan ?? {},
    }),

    tahun() {
      const query = this.$route.query || {};
      return query.tahun;
    },

    juduls() {
      let types = {
        0: 'Forum Koordinasi dan Komunikasi FSP',
        1: 'Observasi PMO Level Sekolah',
        2: 'PMO Level Daerah',
      };

      if (+this.pendampingan_tahun === 2023 || +this.tahun === 2023) {
        types = Object.assign({}, types, { 3: 'Laporan Perkembangan PSP' });
      }

      return types;
    },

    tabItems() {
      let items = [
        { label: this.juduls[0], component: 'Laporan', form: 'fasilitator', masterInstrumen: 'fsp|fsp-sekolah' },
        { label: this.juduls[1], component: 'LaporanSekolah', form: 'sekolah', masterInstrumen: 'sekolah' },
        { label: this.juduls[2], component: 'Laporan', form: 'daerah', masterInstrumen: 'daerah' },
      ];

      if (+this.pendampingan_tahun === 2023 || +this.tahun === 2023) {
        items = [
          ...items,
          ...[{ label: this.juduls[3], component: 'LaporanProgres', form: 'progres', masterInstrumen: 'progres' }],
        ];
      }

      return items;
    },

    status() {
      return {
        '-1': { color: 'red', label: 'Belum dikerjakan' },
        '0': { color: 'blue', label: 'Dalam pengerjaan' },
        '1': { color: 'green', label: 'Lengkap' },
        '2': { color: 'orange', label: 'Tidak ada pelaporan' },
      };
    },

    mTahunPendampingan() {
      const tahunPendampingan = this.$getDeepObj(this.configPendampingan, 'koordinator-pa.tahun');
      let tahuns = [];

      for (let tahun = tahunPendampingan; tahun >= 2022; tahun--) {
        tahuns.push({
          text: `Tahun Pendampingan ${tahun}`,
          value: tahun,
        });
      }

      return tahuns;
    },
  },
  created() {
    this.getMasters('koordinator_moda_psp;koordinator_alasan_psp;propinsi;kota');
    this.tab = 0;
  },
  methods: {
    ...mapActions('master', ['getMasters']),
    ...mapActions('koordinatorFsp', [
      'fetch',
      'fetchDetail',
      'fetchLaporan',
      'fetchInstrumen',
      'listSekolah',
      'update',
      'createProgres',
      'updateProgres',
    ]),

    getPayloads(pendampingan_ke) {
      const kLaporan = this.tab + 1;

      if (!this.pendampingan_tahun) {
        this.pendampingan_tahun = this.tahun || this.$getDeepObj(this.configPendampingan, 'koordinator-pa.tahun');
      }

      let params = { k_koordinator_laporan_psp: kLaporan, pendampingan_tahun: this.pendampingan_tahun };
      if ([1, 3].includes(+this.tab)) {
        params = Object.assign({}, params, { pendampingan_ke: pendampingan_ke || this.meta.pendampingan_ke });
      }

      let payloads = { params };
      if (this.akunInstansiId) {
        payloads['id'] = this.akunInstansiId;
      }

      return payloads;
    },

    async getLaporans(payloads) {
      return await this[this.akunInstansiId ? 'fetchDetail' : 'fetch'](payloads);
    },

    async getLaporan(pendampingan_ke = null, reset) {
      const payloads = this.getPayloads(pendampingan_ke);
      const resp = await this.getLaporans(payloads);
      const data = resp?.data ?? [];

      this.pendampingan_ke = pendampingan_ke;
      this.meta = resp?.meta ?? {};
      this.laporans = {};
      this.laporansFsp = {};
      this.laporansProgres = {};

      if (this.tab === 1 || this.tab === 3) {
        if (reset) {
          this.$nextTick(() => {
            if (this.$refs[`laporan-${this.tab}`] && this.$refs[`laporan-${this.tab}`]['reset']) {
              this.$refs[`laporan-${this.tab}`]['reset']();
            }
          });
        }

        for (const laporan of data) {
          const pspProfilPa = laporan.psp_profil_pa || {};
          this.laporansFsp[pspProfilPa.psp_profil_id] = laporan;
        }

        for (const pa of this.meta.pa || []) {
          if (!this.laporansFsp[pa.psp_profil_id]) {
            this.laporansFsp[pa.psp_profil_id] = {};
          }
        }
      }

      if (this.pendampingan_tahun >= 2024) {
        this.laporans = this.$arrToObj(data, 'k_koordinator_laporan_psp');
      } else {
        for (const laporan of data) {
          this.laporans[laporan.pendampingan_ke] = laporan;
          this.laporansProgres[laporan.pendampingan_ke] = laporan.psp_kp_pa_koordinator_laporan_progreses || [];
        }
      }

      if (!pendampingan_ke) {
        this.$refs[`laporan-${this.tab}`].pendampinganKe = this.meta.pendampingan_ke;
      }

      if (this.akunInstansiId) {
        this.$emit('emit', this.meta);
      }
    },

    onChangeTahunPendampingan() {
      if (this.tab !== 0) {
        this.tab = 0;
        return;
      }

      this.onChangeTab();
    },

    onChangeTab() {
      this.getLaporan(1, true);
    },

    onChangePendampingan(pendampinganKe) {
      if (+this.pendampingan_ke === +pendampinganKe) {
        this.pendampingan_ke = null;
        return;
      }

      this.getLaporan(pendampinganKe);
    },

    async onEditLaporan(data) {
      const pendampinganKe = data.pendampinganKe;
      const fsp = data.fsp || {};
      const type = data.form || '';
      const progresId = data.progresId || '';
      const isPreview = data.isPreview || false;

      // edit laporan 2024
      if (type === 'ds24') {
        await this.onEditLaporan2024(data);
        return;
      }

      // get instrumen
      if (type === 'progres-psp') {
        await this.getMasters(
          ['koordinator_topik_psp', 'koordinator_subtopik_psp|value:k_koordinator_topik_psp+keterangan'].join(';')
        );
      } else {
        await this.fetchInstrumen();
      }

      let laporan = this.laporans[pendampinganKe];
      if (this.$isObject(fsp)) {
        laporan = this.laporansFsp[fsp.psp_profil_id] || {};
      } else if (progresId) {
        laporan = this.$getDeepObj(this.laporansProgres, `${pendampinganKe}.${progresId - 1}`) || {};
      }

      let detail = {};
      if (type === 'progres-psp') {
        detail = Object.assign({}, laporan);
      } else if (this.$isObject(laporan)) {
        detail = await this.fetchLaporan({ id: laporan.psp_kp_pa_koordinator_laporan_id });
      }

      // List daftar sekolah PA
      let sekolahs = [];
      if (this.tab === 1) {
        sekolahs = await this.listSekolah({ id: fsp.psp_profil_id });
      }

      const info = {
        meta: this.meta,
        bulan: this.meta.pendampingan[pendampinganKe],
        pendampingan_ke: pendampinganKe,
        pendampingan_tahun: this.pendampingan_tahun,
        laporan: detail,
        fsp,
      };

      this.$set(this.formulir, 'title', `Formulir Laporan ${this.juduls[this.tab]}`);
      this.$set(this.formulir, 'type', type);
      this.$set(this.formulir, 'info', info);
      this.$set(this.formulir, 'form', type === 'progres-psp' ? 'FormProgres' : 'FormKoordinator');
      this.$set(this.formulir, 'isPreview', isPreview);
      this.$set(this.formulir, 'sekolahs', sekolahs);
      this.$set(this.formulir, 'berkases', detail.psp_kp_pa_koordinator_laporan_berkases || []);

      if (progresId) {
        this.$set(this.formulir, 'progresId', progresId);
      }

      this.$refs.modal.open();
      this.$nextTick(() => {
        this.$refs.formulir.reset();
      });
    },

    async onEditLaporan2024(data) {
      const kegiatans = data.kegiatans || {};
      const kegiatan = kegiatans[data.kLaporan] || {};
      const laporan = this.laporans[data.kLaporan] || {};
      const detail = this.$isObject(laporan)
        ? await this.fetchLaporan({ id: laporan.psp_kp_pa_koordinator_laporan_id })
        : {};
      const berkases = detail.psp_kp_pa_koordinator_laporan_berkases || [];

      const info = {
        meta: this.meta,
        bulan: this.meta.pendampingan[data.pendampinganKe],
        pendampingan_ke: kegiatan.pendampingan_ke,
        pendampingan_tahun: this.pendampingan_tahun,
        laporan: detail,
        fsp: data.fsp || {},
        kegiatan: kegiatan,
        k_laporan: data.kLaporan || '',
        fasilitators: data.fasilitators || [],
        opsis: data.opsis || {},
      };

      this.$set(this.formulir, 'title', `Formulir Laporan Pendampingan KFSP`);
      this.$set(this.formulir, 'type', data.form);
      this.$set(this.formulir, 'info', info);
      this.$set(this.formulir, 'form', 'FormKoordinator');
      this.$set(this.formulir, 'isPreview', data.isPreview || false);
      this.$set(this.formulir, 'berkases', berkases);

      this.$refs.modal.open();
      this.$nextTick(() => {
        this.$refs.formulir.reset();
      });
    },

    async onRefreshLaporan({ type, info }) {
      let laporan = this.laporans[info.pendampingan_ke];
      if (type === 'ds24') {
        laporan = info.laporan;
      }

      if (!laporan) {
        await this.getLaporan(info.pendampingan_ke);
        laporan = this.laporans[info.pendampingan_ke] || {};
      }

      const detail = await this.fetchLaporan({ id: laporan.psp_kp_pa_koordinator_laporan_id });
      const berkases = detail.psp_kp_pa_koordinator_laporan_berkases || [];
      this.$set(this.formulir, 'berkases', berkases);
    },

    onSaveLaporan() {
      let params = this.$refs.formulir.getValue();
      const type = this.formulir.type;
      const info = this.formulir.info;
      const laporanProgresId = this.$getDeepObj(info, 'laporan.psp_kp_pa_koordinator_laporan_progres_id');

      if (params.is_terlaksana === 1) {
        // delete params['k_koordinator_alasan_psp'];
        // delete params['alasan_lain'];
      } else if (params.is_terlaksana === 0) {
        params['k_koordinator_alasan_psp'] = 9;
      }

      let action = 'update';
      if (type === 'progres-psp') {
        action = laporanProgresId ? 'updateProgres' : 'createProgres';
      }

      let payloads = { params };
      if (action === 'updateProgres') {
        payloads = { id: laporanProgresId, params };
      }

      this[action](payloads)
        .then(() => {
          this.$success(`Berhasil disimpan`);
          this.getLaporan(params.pendampingan_ke);
          this.$refs.modal.close();
        })
        .catch(() => {
          this.$refs.modal.loading = false;
        });
    },
  },
  watch: {
    tab: 'onChangeTab',
  },
};
</script>

<style scoped>
.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
.sc-notif {
  background-color: #c8e6c9;
}
</style>
